import React        from 'react';
import PropTypes    from 'prop-types';
import Block        from './../Block';
import Translations from '../../../utils/Translations';
import Header       from './Header';
import ButtonRow    from './ButtonRow';
import Jumbotron    from '../../Video/Jumbotron';
import Flux         from '../../../flux/Flux';
import {trackClick} from '../../../utils/GAHelper';

const HOMEPAGE_TYPE = Flux.Constants.Video.Jumbotron.TYPE_HOMEPAGE;

class VideoStationBlock extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			items: this.props.config ? this.props.config : Flux.Video.Jumbotron.getConfig(HOMEPAGE_TYPE),
		};

		this.onItemsReceivedHandler = this.onItemsReceivedHandler.bind(this);
	}


	componentDidMount() {
		if (!this.state.items) {
			Flux.Video.Jumbotron.addConfigChangeListener(this.onItemsReceivedHandler);
			Flux.Video.Jumbotron.loadConfig(HOMEPAGE_TYPE);
		}
	}

	componentWillUnmount() {
		Flux.Video.Jumbotron.removeConfigChangeListener(this.onItemsReceivedHandler);
	}

	// arguments will be passed from store via `emit()`
	onItemsReceivedHandler(config, type) {
		// skip if wrong type
		if (type !== HOMEPAGE_TYPE) {
			return;
		}
		this.setState({
			items: Flux.Video.Jumbotron.getConfig(HOMEPAGE_TYPE),
		});
	}

	render() {
		// do not show for logged in
		if (this.props.isGuestLoggedIn) {
			return null;
		}
		return (
			<Block className="video-station" idName="video-station-block">
				<Header
					title={this.props.title}
					headlineType={this.props.headlineType}
					hasCount={false}
				/>
				<Jumbotron
					{...this.state.items}
					isMobile={this.props.isMobile}
					lazyImageLoading={this.props.lazyImageLoading}
					showForegroundText={false}
				/>
				<ButtonRow
					cta={Translations.get('HomepageV2TrendingVideosCTA')}
					link={this.props.link}
					callback={() => this.props.doGaTracking ? trackClick('video-station', this.props.link) : null}
				/>
			</Block>
		);
	}
}

VideoStationBlock.propTypes = {
	config:           PropTypes.object,
	link:             PropTypes.string.isRequired,
	isGuestLoggedIn:  PropTypes.bool,
	isMobile:         PropTypes.bool,
	lazyImageLoading: PropTypes.bool,
	headlineType:     PropTypes.oneOf(Object.values(Flux.Constants.Headlines)),
	title:            PropTypes.string,
	doGaTracking:     PropTypes.bool,
};

VideoStationBlock.defaultProps = {
	isGuestLoggedIn:  false,
	isMobile:         false,
	lazyImageLoading: false,
	headlineType:     Flux.Constants.Headlines.h2,
	title:            Translations.get('HomepageV2VideoStationTitle'),
	doGaTracking:     false,
};

export default VideoStationBlock;
